import { render } from "./InvoiceItemsInput.vue?vue&type=template&id=4a23de8e"
import script from "./InvoiceItemsInput.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__